import {useState} from "react"
import { Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

export default function AploadPaper(){
    const navigate = useNavigate();
    const [newPaper, setNewPaper] = useState({
      	name:'',
        paper:'',
        subject:'',
		school:'',
        paper_year:'',
        grade_category:'',
        grade_level:'',
    })
    
    // const [selectedFile, setSelectedFile] = useState(null)

    const handleChange = (e)=>{
        setNewPaper({...newPaper, [e.target.name]: e.target.value})
    }

    const handleFileChange = (e)=>{
       setNewPaper({...newPaper, paper: e.target.files[0]})
    }

    const handleSubmit = (event)=>{
        const formData = new FormData()
        formData.append("subject", newPaper.subject)
		formData.append("school", newPaper.school)
        formData.append("year", newPaper.paper_year)
        formData.append("grade_category", newPaper.grade_category)
        formData.append("grade_level", newPaper.grade_level)
      	formData.append("name", newPaper.paper)
        
        // formData.append("file", selectedFile)

        event.preventDefault();

        const user = JSON.parse(localStorage.getItem("user"));

        console.log(user.accessToken);

        try {
            const response = axios.post('https://coda.easylinksmw.com/api/paper/addPaper', formData, {
                headers : {authorization : "Bearer " + user.accessToken}
            } );
            console.log('Response: ', response.data);
            toast.success('Paper uploaded succcessfully')
            //navigate('/create');
            //window.location.reload();
             setNewPaper({
               	name:'',
                paper:'',
                subject:'',
                school:'',
                year:'',
                grade_category:'',
                grade_level:'',               
             });
               
        } catch (error) {
            if(error){
                // The request was made and the server responded with a status code
                console.error('Server responded with error:', error.response.data);
                console.error('Status code:', error.response.status);
                toast.success('Paper uploaded succcessfully')
                navigate('/create');
            }
        }

    }
    
    return(
        <div style={{marginTop: 20}}>
            <div className="row">
                <div className="col-md-6 offset-md-3">
                <h3 className="text-center ">Upload new past Paper </h3>
                <Form encType ="multipart/form-data" method="post">
                    {/* <Form.Group className="mb-3" controlId="paper_name">
                        <Form.Label>Paper Name</Form.Label>
                        <Form.Control onChange={handleChange} name="paper_name" value={newPaper.paper_name}  type="text" placeholder="paper name" />
                    </Form.Group> */}
                    <Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control onChange={handleChange} name="subject" value={newPaper.subject}  type="text" placeholder="subject" />
                    </Form.Group>
					<Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>School</Form.Label>
                        <Form.Control onChange={handleChange} name="school" value={newPaper.school}  type="text" placeholder="School" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="phone">
                        <Form.Label>Grade Category</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_category" value={newPaper.grade_category}  type="text" placeholder="Category">
                            <option>Select Grade</option>
                            <option value="JCE">JCE</option>
                            <option value="MSCE">MSCE</option>
							<option value="PSLCE">PSLCE</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="year">
                        <Form.Label>Paper Year</Form.Label>
                        <Form.Select onChange={handleChange} name="paper_year" value={newPaper.year}  type="number" placeholder="Year">
                            <option>Select Year</option>
							<option value="2026">2026</option>
							<option value="2025">2025</option>
							<option value="2024">2024</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                            <option value="2019">2019</option>
                            <option value="2018">2018</option>
                            <option value="2017">2017</option>
                            <option value="2016">2016</option>
                            <option value="2015">2015</option>
                            <option value="2014">2014</option>
                            <option value="2013">2013</option>
                            <option value="2012">2012</option>
                            <option value="2011">2011</option>
                            <option value="2010">2010</option>
                            <option value="2009">2009</option>
                            <option value="2008">2008</option>
                            <option value="2007">2007</option>
                            <option value="2006">2006</option>
                            <option value="2005">2005</option>
                            <option value="2004">2004</option>
                            <option value="2003">2003</option>
                            <option value="2002">2002</option>
                            <option value="2001">2001</option>
                            <option value="2000">2000</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="grade_level">
                        <Form.Label>Level</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_level" value={newPaper.grade_level}  type="text" placeholder="Level">
                            <option>Select Level</option>
                            <option value="Form 1">Form One</option>
                            <option value="Form 2">Form Two</option>
                            <option value="Form 3">Form Three</option>
                            <option value="Form 4">Form Four</option>
							<option value="pslce">PSLCE</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="last_name">
                        <Form.Label>Select File</Form.Label>
                        <Form.Control name="paper" type="file" onChange={handleFileChange} />
                    </Form.Group>
                    <Button
                        style={{width:'100%', marginTop:'1rem'}} 
                        onClick={handleSubmit} 
                        variant="primary">
                        Submit
                    </Button>
                </Form>
                </div>
            </div>           
        </div>
    )
}